window.PXUTheme.jsIconWithTextColumn = {
  init: function($section) {
    $section.on('click.klaviyoPopup', '[data-klaviyo-form-id]', function(event) {
      event.preventDefault();

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.openForm(this.dataset.klaviyoFormId, function() {
        console.log('Form Triggered');
      });
    });
  },
  unload: function($section) {
    $section.off('click.klaviyoPopup', '[data-klaviyo-form-id]');
  }
};
